import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import CustomProvider from 'components/CustomProvider';
import ForgotPasswordForm from './ForgotPasswordForm';

type Props = {
  resourceName: string;
  locale: LanguageRegionCode;
  forgotPasswordUrl: string;
};

export default function ForgotPasswordFormWrapper(props: Props) {
  return (
    <CustomProvider>
      <ForgotPasswordForm {...props} />
    </CustomProvider>
  );
}
